import React from 'react'

const Footer = () => {
  return (
    <div className='mt-24'>
        <p className="dark:text-gray-200 text-gray-700 text-center m-20">
            @ 2025 All rights reserved by sen'alerts.
        </p>
    </div>
  )
}

export default Footer